import { useEffect } from "react";
import { IFRAME_ID } from "./constants";
import { useGoogleFonts } from "./useGoogleFonts";

/**
 * Hook that dynamically injects Google Fonts links into the BuilderUI iframe
 * without causing iframe refreshes.
 */
export const useDynamicGoogleFonts = () => {
  const { getGoogleFontsLinks } = useGoogleFonts();

  useEffect(() => {
    const iframe = document.getElementById(IFRAME_ID) as HTMLIFrameElement;
    if (!iframe?.contentDocument) return;

    const googleFontsLinks = getGoogleFontsLinks();
    if (!googleFontsLinks) return;

    const iframeDocument = iframe.contentDocument;
    if (!iframeDocument) return;

    const existingGoogleFontLinks = iframeDocument.querySelectorAll(
      'link[href*="fonts.googleapis.com"], link[href*="fonts.gstatic.com"]',
    );
    for (const link of Array.from(existingGoogleFontLinks)) {
      link.remove();
    }

    const temporaryContainer = document.createElement("div");
    temporaryContainer.innerHTML = googleFontsLinks;

    const newLinks = temporaryContainer.querySelectorAll("link");
    for (const link of Array.from(newLinks)) {
      iframeDocument.head.appendChild(link.cloneNode(true));
    }
  }, [getGoogleFontsLinks]);
};
